import { Bell } from "lucide-react";

interface NotificationBellProps {
    hasNotification: boolean;
}

export function NotificationBell({ hasNotification }: NotificationBellProps) {
    return (
        <>
            {hasNotification && (
                <span
                    aria-hidden="true"
                    className="bg-destructive absolute top-1.5 right-1.5 size-2 rounded-full"
                />
            )}
            <Bell />
        </>
    );
}
